// extracted by mini-css-extract-plugin
module.exports = {"sticker":"Sticker-module--sticker--2pz11"};